/**
 * AgentDisconnectButton - Hybrid/RoomContext version for LiveKit manually managed rooms.
 * Uses useRoomContext and room.disconnect() instead of useSessionContext.
 * Use with LiveKitRoom (connect={false}) for hybrid approach.
 *
 * @see https://docs.livekit.io/reference/components/agents-ui/component/agent-control-bar/
 */
import { Button } from '../ui/ui/button';
import { cn } from '../../lib/utils';
import { useRoomContext } from '@livekit/components-react';
import { PhoneOffIcon } from 'lucide-react';
import { useCandidateT } from '../../i18n/candidate';

export function AgentDisconnectButton({
  icon,
  size = 'default',
  variant = 'destructive',
  children,
  onClick,
  disabled,
  ...props
}) {
  const room = useRoomContext();
  const t = useCandidateT();

  const handleClick = (event) => {
    onClick?.(event);
    if (room) {
      room.disconnect();
    }
  };

  return (
    <Button data-testid="end-call-btn" size={size} variant={variant} onClick={handleClick} disabled={disabled} {...props}>
      {icon ?? <PhoneOffIcon />}
      {children ?? <span className={cn(size?.includes('icon') && 'sr-only')}>{t('END CALL')}</span>}
    </Button>
  );
}
